import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import customTestingProcedures from './customTestingProcedure';
import editCustomTestingProceduresDialog from './customTestingProcedure/dialog.editCustomTestingProceduresDialog';
import controller from './risk-monitoring-and-testing.controller';
import directive from './risk-monitoring-and-testing.directive';

export default angular.module('app.components.advisory.bcp.riskMonitoringAndTesting', [
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
  customTestingProcedures,
  editCustomTestingProceduresDialog,
])
  .directive('bcpRiskMonitoringAndTesting', directive)
  .controller('RiskMonitoringAndTestingController', controller)
  .name;

console.log('app.components.advisory.bcp.riskMonitoringAndTesting created');
